import { Button, CircularProgress, useTheme } from '@mui/material';
import { ReactNode } from 'react';

type buttonType = 'button' | 'submit' | 'reset' | undefined;

interface PrimaryButtonProps {
  children: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  type?: buttonType;
  action?: (e: any) => void;
  minWidth?: string;
  minHeight?: string;
  sx?: object;
}
const PrimaryButton = ({
  children,
  disabled = false,
  loading = false,
  type,
  action,
  minWidth,
  minHeight,
  sx
}: PrimaryButtonProps) => {
  const theme = useTheme();

  return (
    <Button
      type={type}
      onClick={action}
      disabled={disabled}
      color="primary"
      variant="contained"
      disableElevation
      sx={{ borderRadius: 2, minWidth: minWidth, minHeight: minHeight, ...sx }}
    >
      {loading ? (
        <CircularProgress size="1rem" sx={{ color: theme.palette.text.primary }} />
      ) : (
        children
      )}
    </Button>
  );
};

export default PrimaryButton;
